import { CircularProgressProps as MuiCircularProgressProps } from '@mui/material';
import {
  ValueStyled,
  WrapperStyled,
  CircularProgressStyled,
  CircularProgressBackgroundStyled,
} from './styled';

type CircularProgressWithValueProps = Omit<MuiCircularProgressProps, 'size'> & {
  size: number;
  value: number;
  classNameContainer?: string;
};

export const CircularProgressWithValue = ({
  size,
  value,
  ...props
}: CircularProgressWithValueProps) => {
  const valueRounded = Math.round(value);

  return (
    <WrapperStyled $size={size} className={props.className}>
      <CircularProgressBackgroundStyled {...props} size={size} variant="determinate" value={100} />
      <CircularProgressStyled {...props} size={size} variant="determinate" value={valueRounded} />
      <ValueStyled variant="text-heading-2xl">{`${valueRounded}%`}</ValueStyled>
    </WrapperStyled>
  );
};
